import { config } from '@lingoda/config';
import { getHost } from './getHost';

const generateSubdomain = (subdomain: string) =>
    [subdomain, ...getHost().split('.').slice(1)].join('.');

export const getMarketingDomain = () => generateSubdomain('www');

export const getTeacherDomain = () => config.domains?.en_TEACHER || generateSubdomain('teacher');

export const getClassroomDomain = () => {
    const name = 'class';
    const isInDev = getHost().split('.').pop() === 'wip';
    if (isInDev) {
        return generateSubdomain(name);
    }

    // We will keep CLASSROOM_CBE since it was fully rollout now.
    // Note: cleanup needed after ~1 month from rollout.
    return config.domains?.CLASSROOM_CBE || generateSubdomain(name);
};

export const getStudentDomain = () => {
    const isInDev = getHost().split('.').pop() === 'wip';
    if (isInDev) {
        return generateSubdomain('learn');
    }

    return config.domains?.STUDENT || generateSubdomain('learn');
};
